import {
  GoogleMap,
  MarkerF
} from "@react-google-maps/api";
import React from "react";

interface MapProps {
  center: google.maps.LatLngLiteral;
  onMarkerDragEnd?: (lat: number, lng: number) => void;
  dragable?: boolean;
}

const Maps: React.FC<MapProps> = ({ center, onMarkerDragEnd, dragable=false }) => {
  const options = {
    mapTypeControl: false, 
    zoomControl: false, 
    streetViewControl: false, 
    fullscreenControl: false, 
  };
  return (
    <>
      {
        <GoogleMap
          id="map"
          mapContainerStyle={{ width: "100%", height: "100%" }}
          zoom={15}
          center={center}
          options={options}
        >
          <MarkerF
            position={center}
            draggable={dragable}
            onDragEnd={(e) =>
              onMarkerDragEnd ? onMarkerDragEnd(e.latLng?.lat() ?? 0, e.latLng?.lng() ?? 0) : console.log(e)
            }
          />
        </GoogleMap>
      }
    </>
  );
};

export default Maps;
